import { render, staticRenderFns } from "./AuthMngUserBu.vue?vue&type=template&id=60ddda25"
import script from "./AuthMngUserBu.vue?vue&type=script&lang=js"
export * from "./AuthMngUserBu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports